import './scss/app.sass';

document.documentElement.classList.add('notranslate');

window.addEventListener("load", async () => {
    const urlParams = new URLSearchParams(window.location.search);
    // const type = urlParams.get('type');
    const url = urlParams.get('redirect');

    //TODO: Add whitelist of domains for redirect
    if(url === null){
        window.location.replace('https://mdinc.ru');
    }else{
        window.location.replace(url);
    }

});



